import { FC, useState } from 'react'

import { NavFooter } from '../../nav/NavFooter'
import { NavHeader } from '../../nav/NavHeader'
import { SearchOverlay } from '../search/Search/SearchOverlay'

import { SlideItemProps } from './constants'
import { PageContent, PageWrapper } from './style'

import { MobileAppBody } from './'

interface MobileAppPageProps {
  title: string
  description: string
  slideItems: SlideItemProps[]
  qrCode: string
  qrTitle: string
  titleLetterSpacing?: number
}

const MobileAppPage: FC<MobileAppPageProps> = ({
  title,
  description,
  slideItems,
  qrCode,
  qrTitle,
  titleLetterSpacing,
}) => {
  const [isFixed, setIsFixed] = useState(0)

  return (
    <PageWrapper>
      <PageContent isFixed={isFixed}>
        <SearchOverlay />
        <NavHeader />
        <MobileAppBody
          title={title}
          subTitle={description}
          qrTitle={qrTitle}
          qrCode={qrCode}
          slideItems={slideItems}
          titleLetterSpacing={titleLetterSpacing}
          setIsFixed={setIsFixed}
        />
        <NavFooter />
      </PageContent>
    </PageWrapper>
  )
}

export default MobileAppPage
